import { render, staticRenderFns } from "./addDepartmentModal.vue?vue&type=template&id=7fcabb76&scoped=true"
import script from "./addDepartmentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./addDepartmentModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./addDepartmentModal.vue?vue&type=style&index=0&id=7fcabb76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcabb76",
  null
  
)

export default component.exports